var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgModeDarkicon = function SvgModeDarkicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.157 1.607a.8.8 0 0 1-.054.868 3.877 3.877 0 0 0 5.422 5.422.8.8 0 0 1 1.272.717 6.813 6.813 0 1 1-7.411-7.41.8.8 0 0 1 .77.403ZM5.98 3.187a5.213 5.213 0 1 0 6.832 6.833 5.477 5.477 0 0 1-6.832-6.833Z",
    clipRule: "evenodd"
  })));
};
export default SvgModeDarkicon;